import Css from "./style.module.scss";

import { Select } from "nlib/ui";
import { getAllUsersData } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React, { useCallback, useMemo } from "react";
import UserRoles from "const/UserRoles";
import getUserEmailOptionLabel from "../../../getUserEmailOptionLabel";

const SelectDefaultAccountant = ({ value, disabled, businessId, onChange, ...restProps }) => {
  const { uiTexts } = useSelector(getTextsData);

  const usersData = useSelector(getAllUsersData);

  const accountantUsers = useMemo(() => {
    return usersData.filter(({ role, businessIds = [] }) => {
      return !UserRoles.checkIsBusiness(role) && (!businessIds.length || businessIds.includes(businessId));
    }).filter(({ email }) => !!email);
  }, [businessId, usersData]);

  const groups = useMemo(() => {
    return [
      { value: "0", label: uiTexts.accountants }
    ];
  }, [uiTexts]);

  const options = useMemo(() => {
    return accountantUsers.map((user) => ({
      value: user.email.toLowerCase(),
      label: getUserEmailOptionLabel(user),
      group: "0"
    }));
  }, [accountantUsers]);

  const handleChange = useCallback((newValue) => {
    onChange(newValue);
  }, [onChange]);

  return (
    <div className={Css.selectDefaultAccountant}>
      <Select
        options={options}
        groups={groups}
        value={value}
        className={Css.input}
        buttonClassName={Css.button}
        disabled={disabled}
        placeholder={uiTexts.selectAccountantEmail}
        onChange={handleChange}
        {...restProps} />
    </div>
  );
};

export default React.memo(SelectDefaultAccountant);
